import type { RouteObject } from 'react-router';
import { PageDelegations } from './PageDelegations';
import { PageHabilitations } from './PageHabilitations';
import { PageHistorique } from './PageHistorique';
import { PageRoles } from './PageRoles';
import { PageUtilisateurs } from './PageUtilisateurs';

/** Routes dont les contrôleurs sont raccordés au socle. Les autres sources sont conservées. */
export const routesNoyau: RouteObject[] = [
  { path: '/administration/utilisateurs', element: <PageUtilisateurs /> },
  { path: '/administration/roles', element: <PageRoles /> },
  { path: '/administration/habilitations', element: <PageHabilitations /> },
  { path: '/administration/delegations', element: <PageDelegations /> },
  { path: '/administration/historique', element: <PageHistorique /> },
];
